import React from 'react';

const projects = [
  {
    id: 1,
    client: 'Timothy Andre',
    title: 'Photography Portfolio',
    description:
      "Website showcasing images captured for weddings, portrait shots, and cars, and offers photography services to commercial or for personal use.",
    tags: ['React', 'Image Gallery','Responsive','Contact Form', 'Multi-page'],
    link: 'https://createdbytimphotography.com',
    year: '2024',
  },
  {
    id: 2,
    client: 'My project',
    title: 'Chess Search Engine',
    description:
      "A Search engine providing stats and information on a given player from chess.com.",
    tags: ['React', 'REST API', 'Search', 'Data Visualization'],
    link: 'https://chess-pro-f6e9e.web.app/',
    year: '2024',
  },
];

const getFaviconUrl = (link) => {
  try {
    const { origin, hostname } = new URL(link);
    return {
      primary: `${origin}/favicon.png`,
      fallback: `${origin}/favicon.ico`,
      lastResort: `https://www.google.com/s2/favicons?sz=64&domain=${hostname}`,
    };
  } catch {
    return null;
  }
};

const Projects = () => {
  return (
    <section id="work">
      <div className="container">
        <div className="section-label">Work</div>
        <div className="projects-list">
          {projects.map((project, i) => (
            <div className="project-card" key={project.id}>
              <div className="project-meta">
                <span className="project-number">0{i + 1}</span>
                <span className="project-year">{project.year}</span>
              </div>
              <div className="project-title-row">
                {(() => {
                  const favicon = getFaviconUrl(project.link);
                  return (
                    <img
                      src={favicon?.primary}
                      alt={project.title}
                      className="project-image"
                      onError={(e) => {
                        if (e.target.src === favicon?.primary && favicon?.fallback) {
                          e.target.src = favicon.fallback;
                        } else if (e.target.src === favicon?.fallback && favicon?.lastResort) {
                          e.target.src = favicon.lastResort;
                        }
                      }}
                    />
                  );
                })()}
                <h3 className="project-title">{project.title}</h3>
              </div>
              <p className="project-desc">{project.description}</p>
              <div className="project-footer">
                <div className="project-tags">
                  {project.tags.map((tag) => (
                    <span className="project-tag" key={tag}>{tag}</span>
                  ))}
                </div>
                <a href={project.link} target="_blank" rel="noreferrer" className="project-link-btn">
                  View work
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
